import { formatInTimezone } from '@kioskgaming/ui';

export function formatDateTime(
  iso: string | Date | null | undefined,
  timezone: string = Intl.DateTimeFormat().resolvedOptions().timeZone,
): string {
  return formatInTimezone(iso, timezone);
}

export function formatWalletLedgerDate(
  tx: { createdAt?: string | Date | null; created_at?: string | Date | null },
  timezone: string = Intl.DateTimeFormat().resolvedOptions().timeZone,
): string {
  return formatDateTime(tx.createdAt ?? tx.created_at ?? undefined, timezone);
}
